import { ChartColumn, ListChecks } from 'lucide-react';
import { useState } from 'react';
import { useMyAttendance } from '../../api/stats';
import { useMe } from '../../auth/AuthProvider';
import { SECTION_COLOR } from '../../components/people';
import { Button, Sheet } from '../../components/ui';
import { useI18n } from '../../i18n';
import { formatPct, rangeYears } from '../admin/stats/model';
import { AttendanceEventList, Bar, CountsRow } from '../admin/stats/parts';
import { SettingsSection } from './parts';

/**
 * The signed-in member's own attendance this season (Stillingar). Hidden until there is at least one
 * counted event — and while loading, offline without data, or for members without a section.
 */
export function MyAttendanceSection() {
  const { t, loc } = useI18n();
  const me = useMe();
  const q = useMyAttendance(!!me?.section);
  const [open, setOpen] = useState(false);
  const d = q.data;
  if (!me?.section || !d || d.member.userId !== me.id || d.member.total === 0) return null;
  const m = d.member;
  const years = rangeYears(d);

  return (
    <SettingsSection icon={ChartColumn} title={t('stats.my.title')} id="settings-attendance">
      <div className="flex flex-col gap-4 p-5">
        <div className="flex items-center gap-4">
          <span className="text-[44px] leading-none font-bold tabular-nums">{formatPct(m.pct, loc, t('stats.no_pct'))}</span>
          <div className="flex min-w-0 flex-1 flex-col gap-1.5">
            <span className="text-[15px] font-semibold text-[var(--muted)]">{t('stats.season', { years })}</span>
            <Bar pct={m.pct} color={SECTION_COLOR[me.section]} className="h-3.5" />
            <span className="text-[15px] text-[var(--ink-2)]">{t('stats.my.summary', { present: m.present, count: m.total })}</span>
          </div>
        </div>
        <CountsRow present={m.present} excused={m.excused} absent={m.absent} />
        <Button variant="secondary" icon={ListChecks} onClick={() => setOpen(true)} className="self-start">
          {t('stats.my.show_list')}
        </Button>
      </div>
      <Sheet
        open={open}
        onClose={() => setOpen(false)}
        title={t('stats.my.list_title', { years })}
        wide
        footer={
          <Button variant="secondary" block onClick={() => setOpen(false)}>
            {t('common.close')}
          </Button>
        }
      >
        <AttendanceEventList events={d.events} />
      </Sheet>
    </SettingsSection>
  );
}
